module.exports = __webpack_public_path__ + "images/344490aef989d89c682ce78dc2668e3f-illu_waterSensor.svg";